'use strict';
import React from 'react';
import OutsideMixin from 'react-onclickoutside';

var HeaderDropdown = React.createClass({

    propTypes: {
        isOpen: React.PropTypes.bool,
        onClick: React.PropTypes.func
    },

    mixins: [
        OutsideMixin
    ],

    getInitialState() {
        return {
            isActive: this.props.isOpen ? this.props.isOpen : false
        };
    },

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.isOpen !== 'undefined') {
            this.setState({
                isActive: nextProps.isOpen
            });
        }
    },

    toggle(e) {
        e.preventDefault();
        this.setState({
            isActive: !this.state.isActive
        });
        if (this.props.onClick) {
            this.props.onClick();
        }
    },

    handleClickOutside() {
        if (this.props.dropdownClass === 'accordion') {
            return;
        }
        this.setState({
            isActive: false
        });
    },

    renderChildren() {
        if (!this.state.isActive) {
            return null;
        }
        return (
            <div className='item__dropdown'>
                {this.props.children}
            </div>
        );
    },

    render() {
        return (
            <li className="menu__item">
                <a href onClick={this.toggle}>
                    <i className={`play ${this.state.isActive ? 'open': ''}`} ></i>
                    {this.props.label}
                </a>
                {this.renderChildren()}
            </li>
        );
    }
});

module.exports = HeaderDropdown;



// WEBPACK FOOTER //
// ./app/components/header/headerDropdown.jsx